import { HpawResultBadge, QcResultBadge } from '../../utils';

const PackhouseMetric = ({ label, badge, fallback = 'N/A' }) => (
  <div className='d-flex flex-column align-items-center flex-fill p-3'>
    <span className='small text-uppercase mb-2'>{label}</span>
    <h5 className='mb-0'>
      {badge || <span className='text-muted'>{fallback}</span>}
    </h5>
  </div>
);

const PackhouseAssessment = ({ packhouseAssessmentData }) => {
  const packhouseAssessment = packhouseAssessmentData?.[0];

  return (
    <div>
      <div className='mb-1'>
        <h5>Packhouse</h5>
      </div>
      <div
        style={{
          border: '2px solid lightgray',
          borderRadius: '4px'
        }}
      >
        {packhouseAssessment ? (
          <div className='d-flex text-center'>
            <PackhouseMetric
              label='HPAW Spec'
              badge={
                <HpawResultBadge result={packhouseAssessment.hpaw_result} />
              }
            />
            <div style={{ borderLeft: '1px solid lightgray' }} />
            <PackhouseMetric
              label='QC Result'
              badge={<QcResultBadge result={packhouseAssessment.qc_result} />}
            />
          </div>
        ) : (
          <p className='text-muted mb-0 p-3 text-center'>
            No packhouse data available.
          </p>
        )}
      </div>
    </div>
  );
};

export default PackhouseAssessment;

